import styled from '@emotion/styled'
import {Forum} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {MenuPosition} from '~/hooks/useCoords'
import useMenu from '~/hooks/useMenu'
import useSnacksForNewMeetings from '~/hooks/useSnacksForNewMeetings'
import {PALETTE} from '~/styles/paletteV3'
import plural from '~/utils/plural'

import FlatButton from './FlatButton'
import SelectMeetingDropdown from './SelectMeetingDropdown'

const CurrentButton = styled(FlatButton)(({hasMeetings}) => ({
  color: PALETTE.ROSE_500,
  fontSize: 16,
  fontWeight: 600,
  height: hasMeetings ? 50 : 0,
  visibility: hasMeetings ? undefined : 'hidden'
}))

const ForumIcon = styled(Forum)({
  marginRight: 12
})





const NewMeetingActionsCurrentMeetings = (props) => {
  const {team: teamRef} = props
  const team = useFragment(
    graphql`
      fragment NewMeetingActionsCurrentMeetings_team on Team {
        id
        activeMeetings {
          ...SelectMeetingDropdown_meetings
          ...useSnacksForNewMeetings_meetings
          id
        }
      }
    `,
    teamRef
  )
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(
    MenuPosition.LOWER_RIGHT,
    {
      isDropdown: true
    }
  )
  const {activeMeetings} = team
  useSnacksForNewMeetings(activeMeetings )
  const meetingCount = activeMeetings.length
  const label = `${meetingCount} Active ${plural(meetingCount, 'Meeting')}`
  return (
    React.createElement(React.Fragment, null
      , React.createElement(CurrentButton, {
        onClick: togglePortal,
        ref: originRef,
        hasMeetings: meetingCount > 0,
        size: 'large',}

        , React.createElement(ForumIcon, null )
        , label
      )
      , menuPortal(React.createElement(SelectMeetingDropdown, { menuProps: menuProps, meetings: activeMeetings,} ))
    )
  )
}

export default NewMeetingActionsCurrentMeetings
